import React, { useCallback, useMemo } from 'react';
import './tree.scss';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { actions as mailTabActions, tabId } from '@web-common/state/reducer/mailTabReducer';
import { removeAllMiniDrawer, Module } from '@lxunit/app-l2c-crm';
import { api, apiHolder, apis } from 'api';
const loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const MailTab = props => {
    var _a, _b, _c, _d, _e, _f;
    const { active, onActive, config } = props;
    const handleTabClick = useCallback(() => {
        onActive && onActive();
    }, [onActive]);
    const visible = ((_a = config === null || config === void 0 ? void 0 : config.extra) === null || _a === void 0 ? void 0 : _a.showTab) === undefined ? true : (_b = config === null || config === void 0 ? void 0 : config.extra) === null || _b === void 0 ? void 0 : _b.showTab;
    return visible ? (React.createElement("div", { onClick: handleTabClick, className: ` ${active && 'subtab-active'} mail-subtab sirius-no-drag` }, config === null || config === void 0 ? void 0 :
        config.title,
        ((_c = config === null || config === void 0 ? void 0 : config.extra) === null || _c === void 0 ? void 0 : _c.unRead) ? (React.createElement("span", { className: "subtab-number" }, ((_d = config === null || config === void 0 ? void 0 : config.extra) === null || _d === void 0 ? void 0 : _d.unRead) ? (((_e = config === null || config === void 0 ? void 0 : config.extra) === null || _e === void 0 ? void 0 : _e.unRead) > 999 ? '999+' : (_f = config === null || config === void 0 ? void 0 : config.extra) === null || _f === void 0 ? void 0 : _f.unRead) : '')) : (React.createElement(React.Fragment, null)))) : null;
};
const DefaultTabActiveId = '-1/-1';
const DefaultList = [];
const MailSubTab = () => {
    const dispatch = useAppDispatch();
    const subTabList = useAppSelector(state => { var _a, _b; return (_b = (_a = state.mailTabReducer) === null || _a === void 0 ? void 0 : _a.tabList[0]) === null || _b === void 0 ? void 0 : _b.subTabs; }) || DefaultList;
    const curTab = useAppSelector(state => { var _a; return (_a = state.mailTabReducer) === null || _a === void 0 ? void 0 : _a.currentTab; });
    const activeTabId = useMemo(() => {
        var _a, _b, _c;
        const atConfig = subTabList === null || subTabList === void 0 ? void 0 : subTabList.find(item => (item === null || item === void 0 ? void 0 : item.id) == (curTab === null || curTab === void 0 ? void 0 : curTab.id));
        if (((_a = curTab === null || curTab === void 0 ? void 0 : curTab.extra) === null || _a === void 0 ? void 0 : _a.from) && ((_b = curTab === null || curTab === void 0 ? void 0 : curTab.extra) === null || _b === void 0 ? void 0 : _b.from) != '-1' && (curTab === null || curTab === void 0 ? void 0 : curTab.id) != tabId.readCustomer && (curTab === null || curTab === void 0 ? void 0 : curTab.id) != tabId.subordinate && (curTab === null || curTab === void 0 ? void 0 : curTab.id) != tabId.readMain) {
            return (_c = curTab === null || curTab === void 0 ? void 0 : curTab.extra) === null || _c === void 0 ? void 0 : _c.from;
        }
        if (atConfig && (atConfig === null || atConfig === void 0 ? void 0 : atConfig.id)) {
            return atConfig === null || atConfig === void 0 ? void 0 : atConfig.id;
        }
        return DefaultTabActiveId;
    }, [subTabList, curTab === null || curTab === void 0 ? void 0 : curTab.id]);
    const handleTabActive = useCallback((id) => {
        if (activeTabId !== id) {
            dispatch(mailTabActions.doChangeCurrentTab(id));
            if (process.env.BUILD_ISEDM || process.env.BUILD_ISLINGHANG) {
                removeAllMiniDrawer(Module.Email);
            }
        }
        if (id === tabId.subordinate && process.env.BUILD_ISLINGXI) {
            accountApi.doGetAccountIsAdmin().then(isAdmin => {
                const AccountType = isAdmin ? '管理员' : '成员';
                loggerApi.track('pcmail_subordinate_click', { AccountType });
            });
        }
    }, [activeTabId]);
    const TabElement = useMemo(() => {
        return (React.createElement("div", { className: `mail-subtab-wrap ${subTabList.length >= 3 && 'mail-subtab-average'}` }, subTabList.map((config, idx) => {
            return React.createElement(MailTab, { key: idx, active: (config === null || config === void 0 ? void 0 : config.id) == activeTabId, config: config, onActive: () => handleTabActive(config === null || config === void 0 ? void 0 : config.id) });
        })));
    }, [subTabList, activeTabId]);
    if (subTabList.length <= 1) {
        return React.createElement(React.Fragment, null);
    }
    return TabElement;
};
export default MailSubTab;
